import { type ApiInterceptor } from "@modules/core/api/interceptors/apiInterceptor"
import { AxiosHeaders, type InternalAxiosRequestConfig } from "axios"

export const addBoxInterceptor = (getBoxId: () => string | null): ApiInterceptor<InternalAxiosRequestConfig> => ({
  onFulfilled: (config) => {
    const boxId = getBoxId()
    if (!boxId) return config
    if (config.headers instanceof AxiosHeaders) config.headers.set("x-box-id", boxId)
    else config.headers = AxiosHeaders.from(config.headers).set("x-box-id", boxId)
    return config
  },
})
